import React, { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { useAuth } from "../context/AuthContext";

const AccountModal = ({ open, onClose }) => {
  const { session } = useAuth();
  const [isSignUp, setIsSignUp] = useState(false);
  const [form, setForm] = useState({ fullName: "", email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    setError("");
    setMessage("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    if (isSignUp) {
      const { data: authData, error: authError } = await supabase.auth.signUp({
        email: form.email.trim(),
        password: form.password,
        options: {
          data: { full_name: form.fullName.trim(), role: "customer" },
        },
      });

      if (authError || !authData.user) {
        setError(authError?.message || "Erreur de création.");
      } else {
        await supabase.from("profiles").upsert({
          id: authData.user.id,
          full_name: form.fullName.trim(),
          role: "customer",
          is_active: true
        });
        setMessage("Compte créé avec succès ! Vous êtes connecté.");
        setTimeout(() => onClose(), 1500);
      }
    } else {
      const { error: signInError } = await supabase.auth.signInWithPassword({
        email: form.email.trim(),
        password: form.password,
      });

      if (signInError) {
        setError(signInError.message);
      } else {
        onClose();
      }
    }
    setLoading(false);
  };

  if (!open) return null;

  if (session) {
    return (
      <div className="gw-modal-overlay" onClick={onClose}>
        <div className="gw-modal p-4 text-center" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="gw-modal-close" onClick={onClose}>&times;</button>
          <h4>Vous êtes déjà connecté !</h4>
          <button
            className="gw-btn gw-btn-primary gw-btn-block mt-3"
            onClick={async () => { await supabase.auth.signOut(); onClose(); }}
          >
            Se déconnecter
          </button>
          <button className="gw-btn gw-btn-outline gw-btn-block mt-2" onClick={onClose}>Fermer</button>
        </div>
      </div>
    );
  }

  return (
    <div className="gw-modal-overlay" onClick={onClose}>
      <div className="gw-modal" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="gw-modal-close" onClick={onClose} aria-label="Fermer">
          &times;
        </button>

        <div className="gw-modal-head">
          <h2 className="gw-modal-title">{isSignUp ? "Créer un compte" : "Mon compte"}</h2>
          <p className="gw-modal-subtitle">
            {isSignUp ? "Rejoignez-nous pour commander plus rapidement." : "Connectez-vous pour suivre vos commandes et vos favoris."}
          </p>
        </div>

        <form onSubmit={handleSubmit} className="gw-modal-form">
          {isSignUp && (
            <div className="gw-field">
              <label className="gw-field-label" htmlFor="account-name">Nom complet</label>
              <input
                id="account-name"
                type="text"
                name="fullName"
                className="gw-field-input"
                placeholder="Votre nom"
                value={form.fullName}
                onChange={handleChange}
                required={isSignUp}
              />
            </div>
          )}

          <div className="gw-field">
            <label className="gw-field-label" htmlFor="account-email">Email</label>
            <input
              id="account-email"
              type="email"
              name="email"
              className="gw-field-input"
              placeholder="votre@email.com"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="gw-field">
            <div className="gw-field-label-row">
              <label className="gw-field-label" htmlFor="account-password">Mot de passe</label>
              {!isSignUp && (
                <Link to="/MyAccountForgetPassword" className="gw-forgot" onClick={onClose}>
                  Mot de passe oublié
                </Link>
              )}
            </div>
            <div className="gw-password-wrap">
              <input
                id="account-password"
                type={showPassword ? "text" : "password"}
                name="password"
                className="gw-field-input"
                placeholder="••••••••"
                value={form.password}
                onChange={handleChange}
                required
              />
              <button
                type="button"
                className="gw-eye"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Afficher le mot de passe"
              >
                {showPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {error && <div className="alert alert-danger" style={{padding: '0.5rem', fontSize: '0.85rem'}}>{error}</div>}
          {message && <div className="alert alert-success" style={{padding: '0.5rem', fontSize: '0.85rem'}}>{message}</div>}

          <button type="submit" className="gw-btn gw-btn-primary gw-btn-block" disabled={loading}>
            {loading ? "Chargement..." : (isSignUp ? "Créer mon compte" : "Me connecter")}
          </button>

          <div className="gw-divider">
            <span>ou</span>
          </div>

          <button 
            type="button" 
            className="gw-btn gw-btn-outline gw-btn-block"
            onClick={() => {
              setIsSignUp(!isSignUp);
              setError("");
              setMessage("");
            }}
          >
            {isSignUp ? "J'ai déjà un compte" : "Créer un compte"}
          </button>

          <div className="gw-admin-access">
            <span className="gw-admin-line" />
            <Link to="/MyAccountSignIn" className="gw-admin-link" onClick={onClose}>
              Accès administrateur
            </Link>
            <span className="gw-admin-line" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AccountModal;
